import React, {useState, useEffect} from 'react'

export default function Dropdown (props) {
    const [values, setValues] = useState({
        suggestion: [],
        open: false,
        pickedValue: '',
        value: '',
        dropDownItems: []
    })

    let pickName = (e) => {
        let value = props.type === 'number' ? Number(e.target.value) : e.target.value;
        props.handleSelection(props.id, value);
    }

    useEffect(() => {
        let dropDownItems = [];
        if(props.range) {
            let firstVal = Number(props.range[0]);
            let lastVal = Number(props.range[1]);
            for(let i = firstVal; i <= lastVal; i++){
                dropDownItems.push(i);
            }
        } else {
            dropDownItems = props.dropDownItems
        }
        setValues({
            ...values,
            suggestion: dropDownItems,
            dropDownItems: dropDownItems,
            value: props.value,
            placeholder: props.placeholder,
        })
    }, [props]);

    return (
        <div className={`dropdown`}>
            {/* {
                props.hasInput ? <input type={props.type} autoComplete="new-password" id="dropdown" className="place"
                placeholder={(props.placeholder)} onChange={props.hasSearch ? this.findName : this.handleChange} value={props.value}/> : <h4>{this.state.value}</h4>
            } */}
            {/* <i className="fa fa-caret-up inputArrow" id="dropdown" aria-hidden="true" onClick={this.renderAll}></i> */}
            <i className="las la-angle-down inputArrow" id="dropdown" aria-hidden="true" style={{color: '#222', zIndex: '9999'}}></i>
            <select className="dropdownItemsContainer" onChange={pickName} value={props.value}>
                {
                    values.suggestion.map((suggestion, index) => {
                        return (
                            <option id={suggestion} key={index}>{suggestion}</option>
                        )
                    })
                }
            </select>
        </div>
    )
}
